import { useContext } from "react";
import { ConciliationContext } from "../../contexts/conciliationContext";

export const useConciliationContext = () => {
  const context = useContext(ConciliationContext);
  if (!context) {
    throw new Error(
      "useConciliationContext must be used within a ConciliationProvider"
    );
  }
  return context;
};
